import { getParent, types } from 'mobx-state-tree';
import PricingStrategy from './PricingStrategy';
import Image from './Image';
import Property from './Property';

const Variation = types.model('Variation', {
  discoveryItemId: types.maybe(types.number),
  id: types.maybe(types.number),
  mainItemId: types.maybe(types.number),
  images: types.optional(types.array(Image), []),
  pricingStrategy: types.optional(PricingStrategy, {}),
  properties: types.optional(types.array(Property), []),
  sourceItemId: types.string,
  treeDepth: 1,
}).views(self => ({
  get title(){
    return self.properties.reduce(
      (accumulator, currentValue) => `${accumulator}${(accumulator? ', ' : '')}${currentValue.name}: ${currentValue.value}`,
      ''
    );
  },
})).actions(self => ({
  afterCreate(){
    self.mainItemId = getParent(self, 2).id;
  },
}));

export default Variation;
